// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f2425d7a","239":"e9d7523c","455":"c575dffe"}[chunkId] + ".chunk.js";
};